import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ValueForAgencies: React.FC = () => {
  return (
    <section className="py-16 sm:py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            For agencies ready to grow.
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl">
            You've built an agency. Now you want to scale it with the right tools, leads, and support. We can help you do that.
          </p>
        </div>

        {/* What We Offer */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Your own lead store
            </h3>
            <p className="text-slate-600 text-sm">
              We build you a white-label lead center. Your agents buy leads from YOUR platform. You control pricing, products, and margins.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Custom dialer setup
            </h3>
            <p className="text-slate-600 text-sm">
              Not a generic dialer account. A dialer configured for YOUR agency with your call flows, your dispositions, your reporting.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Recruiting funnels
            </h3>
            <p className="text-slate-600 text-sm">
              Landing pages and automations to bring in new agents. You focus on building. We handle the marketing infrastructure.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Onboarding systems
            </h3>
            <p className="text-slate-600 text-sm">
              Get new agents contracted and producing fast. Playbooks, training sequences, and contracting workflows that actually work.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Top carrier partnerships
            </h3>
            <p className="text-slate-600 text-sm">
              We help you access the best carriers in the industry. Your production, your money, your growth.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Real analytics
            </h3>
            <p className="text-slate-600 text-sm">
              Know what's working and what's not. Agent performance, lead ROI, conversion rates, the numbers you need to make decisions.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-navy-800 rounded-2xl p-8 sm:p-10 text-center">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-3">
            Let's talk about your agency.
          </h3>
          <p className="text-navy-200 mb-6 max-w-xl mx-auto">
            Every agency is different. Schedule a call and we'll figure out what you actually need.
          </p>
          <Link 
            to="/for-agencies" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-navy-800 font-semibold rounded-xl hover:bg-slate-100 transition-colors"
          >
            Schedule a Call
            <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ValueForAgencies;
